import React from 'react';
import {Box, Stack, Typography} from "@mui/material";
import {styled} from "@mui/system";
import {Trans} from 'react-i18next';

import ChecklistItem from "./ChecklistItem";
import {SWAP_RATING_CONFIG_MAP} from "../../domain/SwapRating";

const BoldText = styled(Typography)(() => ({
    display: 'inline',
    fontWeight: 'bold',
    fontSize: '0.9rem'
}));

export default function SwapSessionTooltip({swapSessionTooltipDetails, sourcePerformerName}) {
    const {ruleReport, targetPerformerName} = swapSessionTooltipDetails || {};

    return (
        <Box sx={{padding: 1}}>
            <Stack spacing={1}>
            {ruleReport?.filter(({isRuleSkipped}) => !isRuleSkipped)
                    .map(swapRule => {
                        const isRulePassing = swapRule.swapRating === SWAP_RATING_CONFIG_MAP.OK.text;
                        
                        return <ChecklistItem key={swapRule.ruleName} isPassed={isRulePassing}
                            text={
                                <Trans
                                    i18nKey={`swapSessionRules.${swapRule.ruleName}.${isRulePassing ? "pass" : "fail"}`}
                                    values={{ targetPerformerName, sourcePerformerName }}
                                    components={[<BoldText />]} />
                            } />
            })}
            </Stack>
        </Box>
    );
};